import { toast, ToastContainer } from "react-toastify";
function ToastDefault(props:any){

    return(

			<ToastContainer
                autoClose={5000}
                hideProgressBar={true}
                className="toast-chilling"
                position="top-center"
                newestOnTop={false}
                closeOnClick={true}
                rtl={false}
                pauseOnFocusLoss={false}
                draggable={false}
                pauseOnHover={false}
            />


    );
}

export default ToastDefault;